var map = {
	"./01.jpg": 61,
	"./02.jpg": 62,
	"./03.jpg": 63,
	"./all_gray.gif": 64,
	"./banner_img.png": 65,
	"./design1.png": 66,
	"./design2.png": 67,
	"./featured_bg_shape.png": 130,
	"./featured_img1.png": 68,
	"./icon1.png": 131,
	"./icon2.png": 132,
	"./icon3.png": 133,
	"./icon_shape.png": 69,
	"./partners1.gif": 70,
	"./php.jpg": 71,
	"./shap_tecture.png": 134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 904;